const socketMessageType = {
	ATTENDEE_JOINED: "ATTENDEE_JOINED",
	ATTENDEE_LEFT: "ATTENDEE_LEFT",
	CALENDAR_UPDATED: "CALENDAR_UPDATED",
	DIAGNOSTIC: "DIAGNOSTIC",
	GOAL_CREATED: "GOAL_CREATED",
	GOAL_DELETED: "GOAL_DELETED",
	GOAL_UPDATED: "GOAL_UPDATED",
	KEYRESULT_CREATED: "KEYRESULT_CREATED",
	KEYRESULT_DELETED: "KEYRESULT_DELETED",
	KEYRESULT_UPDATED: "KEYRESULT_UPDATED",
	MEETING_UPDATED: "MEETING_UPDATED",
	OUTCOME_CREATED: "OUTCOME_CREATED",
	OUTCOME_DELETED: "OUTCOME_DELETED",
	OUTCOME_UPDATED: "OUTCOME_UPDATED",
	TEAM_CREATED: "TEAM_CREATED",
	TEAM_DELETED: "TEAM_DELETED",
	TEAM_UPDATED: "TEAM_UPDATED",
	TOPIC_CREATED: "TOPIC_CREATED",
	TOPIC_DEFERRED: "TOPIC_DEFERRED",
	TOPIC_DELETED: "TOPIC_DELETED",
	TOPIC_UNDEFERRED: "TOPIC_UNDEFERRED",
	TOPIC_UPDATED: "TOPIC_UPDATED",
	TOPIC_PINNED: "TOPIC_PINNED",
	TOPIC_UNPINNED: "TOPIC_UNPINNED",
	TOPICS_SORTED: "TOPICS_SORTED",
	USER_UPDATED: "USER_UPDATED",
};

export default Object.freeze( socketMessageType );



// WEBPACK FOOTER //
// ./src/constants/SocketMessageType.js